import axiosBasicInstance from '../axiosConfig';

const getListEntitie = async (langId) => {
   try {
      const response = await axiosBasicInstance.get('/management/list-entitie', {
         headers: {
            langId
         },
      });

      return response;
   } catch (error) {
      throw error;
   }
};

const getListEntitieById = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/list-entitie-detail', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getListEntitieByUserId = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/list-entitie-detail-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateSetting = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-setting', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateSettingByUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/update-setting-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const resetSetting = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/reset-setting', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getListRecipients = async (data) => {
   try {
      const response = await axiosBasicInstance.get('/management/get-list-recipients', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addRecipients = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/add-recipients',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const editRecipients = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/edit-recipients',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const deleteRecipients = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-recipients',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const deleteAllRecipients = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-all-recipients',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const getListLocations = async (data) => {
   try {
      const response = await axiosBasicInstance.post(
         '/management/get-list-locations',
         data
      );
      return response;
   } catch (error) {
      throw error;
   }
};

const addLocations = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/add-locations',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const editLocations = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/edit-locations',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const detailLocations = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/get-detail-locations',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const deleteLocations = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/delete-locations',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}


export {
   getListEntitie,
   getListEntitieById,
   updateSetting,
   resetSetting,
   getListRecipients,
   addRecipients,
   editRecipients,
   deleteRecipients,
   deleteAllRecipients,
   updateSettingByUser,
   getListLocations,
   addLocations,
   editLocations,
   detailLocations,
   getListEntitieByUserId,
   deleteLocations
};
